import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Daterangepicker} from 'ng2-daterangepicker';
import {AutoCompleteModule, ConfirmDialogModule, DialogModule, PanelModule} from 'primeng/primeng';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {NgxBarcodeModule} from 'ngx-barcode';
import {routing} from './payouts.routing';
import {SharedTranslationModule} from '../../shared/change-language/shared-translation.module';
import {SafeUrlModule} from '../../shared/custom-pipe/safe-url.module';
import {PayoutsComponent} from './payouts.component';
import { MstBankService } from '../../configuration/mst-bank/mst-bank.service';
import { PayoutsService } from './payouts.service';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
    imports: [
        CommonModule, SharedTranslationModule,
        routing, ReactiveFormsModule,
        Daterangepicker,
        NgxBarcodeModule,
        FormsModule, 
        NgxPaginationModule,
        SharedTranslationModule,
        ConfirmDialogModule,
        DialogModule,
        AutoCompleteModule,
        PanelModule,
        SafeUrlModule
    ],
    declarations: [PayoutsComponent],
    providers: [
        MstBankService, PayoutsService
    ]
})
export class PayoutsModule {
}





// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/accounting/payouts/payouts.module.ts